const sidebarStructure = [
  {
    id: "dashboard",
    title: "Dashboard",
    name: "dashboard",
    parent: false,
    icon: "dasbor",
    link: "dashboard"
  },
  {
    id: "reservations",
    title: "Reservas",
    name: "reservations",
    parent: false,
    icon: "reservas",
    link: "reservations"
   
  } , 
  {
    id: "users",
    title: "Usuarios",
    name: "users",
    parent: false,
    icon: "users",
    link: "users"
   
  },
  {
    id: "reports",
    title: "Reporte",
    name: "reports",
    parent: false,
    icon: "reporte",
    link: "reports"
   
  }  
];

export { sidebarStructure };
